

//#region Action Interfaces

interface DisplayInlineSurveyLinksAction
{
    type: 'DISPLAY_INLINE_SURVEY_LINKS';
    entryId: string;
}

interface DisableInlineSurveyLinksAction
{
    type: 'DISABLE_INLINE_SURVEY_LINKS';
    entryId: string;
}

//#endregion



//#region ActionTypes

export type InlineSurveyLinksActionType = DisplayInlineSurveyLinksAction | DisableInlineSurveyLinksAction;

//#endregion



//#region Action Constructors

export function displayInlineSurveyLinks(entryId: string): InlineSurveyLinksActionType
{
    return {
        type: 'DISPLAY_INLINE_SURVEY_LINKS',
        entryId,
    };
}

export function disableInlineSurveyLinks(entryId: string): InlineSurveyLinksActionType
{
    return {
        type: 'DISABLE_INLINE_SURVEY_LINKS',
        entryId,
    };
}

//#endregion



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-inline-survey-links/src/actions/Actions.ts